import { iSelectGame, iGameModel, iSelectGameType, iVirtualKeyboard, iGameAccount } from '@/interface/game-manage';
import request from '@/utils/request';
/**
 * 游戏讨论-列表
 * @param params
 */
export const getGameForum = (params: any): Promise<any> =>
  request({
    params,
    url: '/api/v1/omc/game/forum',
  });

/**
 * 游戏讨论-列表按照游戏
 * @param data
 */
export const getGameForumByGameID = (params: any): Promise<any> =>
  request({
    url: `/api/v1/omc/forum`,
    params,
  });

/**
 * 游戏讨论-详情
 * @param data
 */
export const getGameForumByGameIDAndId = (game_id: number, id: number): Promise<any> =>
  request({
    url: `/api/v1/omc/game/${game_id}/forum/${id}`,
  });

/* 游戏讨论-删除 */

export const delGorum = (data: any, game_id: number) => {
  return request({
    url: `/api/v1/omc/game/${game_id}/forum`,
    method: 'delete',
    data: { ids: data },
  });
};

/* 游戏讨论-配置-更新 */
export const UpdateForumSetting = (data: any): Promise<any> =>
  request({
    url: `/api/v1/omc/forum/setting`,
    method: 'PUT',
    data,
  });
/* 游戏讨论-配置-获取 */
export const getForumSetting = (): Promise<any> =>
  request({
    url: '/api/v1/omc/forum/setting',
  });
/* 游戏讨论黑名单-查询 */
export const getBlackList = (): Promise<any> =>
  request({
    url: '/api/v1/omc/forum/blacklist',
  });
/* 游戏讨论黑名单-修改 */
export const updateBlackList = (data: any): Promise<any> =>
  request({
    url: `/api/v1/omc/forum/blacklist`,
    method: 'PUT',
    data,
  });
